import { ComponentPropsWithoutRef } from 'react';
import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

interface BaseInputProps extends ComponentPropsWithoutRef<'input'> {
    $hasLeadingVisual: boolean;
    $hasTrailingVisual: boolean;
}

export const BaseInput = styled.input<BaseInputProps>`
    font-size: ${theme.fontSizes[14]};
    font-weight: ${theme.fontWeights[400]};
    color: ${(props) =>
        props.disabled ? theme.colors.foreground.disabled : theme.colors.foreground.default} !important;
    background: transparent;
    border: none;
    width: 100%;
    line-height: 24px;
    padding-top: ${theme.space[4]};
    padding-bottom: ${theme.space[4]};
    padding-left: ${(p) => (p.$hasLeadingVisual ? theme.space[4] : theme.space[8])};
    padding-right: ${(p) => (p.$hasTrailingVisual ? theme.space[4] : theme.space[8])};
    margin: 0;
    transition: padding 75ms;

    &:focus {
        outline: none;
    }

    &::placeholder {
        color: ${theme.colors.foreground.subtle};
    }

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
        -webkit-box-shadow: 0 0 0 60px transparent inset !important;
        background-color: transparent !important;
        background-clip: content-box !important;
    }

    // required for 1Password
    &[data-com-onepassword-filled='light'],
    &[data-com-onepassword-filled='dark'] {
        background-color: transparent !important;
    }
`;
